module.exports = {
	"articleTitle1": "Decadent Dessert: Valentine's Day sweet-tooth overload",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "La Dolce Vita",
	"articleLink1": "#",
	"articleLink2": "http://www.michigandaily.com/article/21st-annual-save-heart-celebration-unites-families",
	"articleSnippet1": "Feb 14, 2013 ... Dim mood lighting and cozy love seats welcome visitors to La Dolce Vita — one \nof Ann Arbor's few purely dessert eateries. The menu, though ...",
	"articleSnippet2": "Nov 24, 2013 ... ... list and food choices from many local restaurants and shops, including \nZingerman's, Afternoon Delight, Conor O'Neills and La Dolce Vita.",
	"foodRecommendations": [],
	"articleTitle2": "Save A Heart raises funds for Mott patients",
	"address": "322 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278797,
		"lng": -83.7489
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/dolcevita.json
// module id = 863
// module chunks = 0